import axios from './axios';

export default designId => (
  axios.get(`estimates/${designId}/eligibility`)
);
